import { render } from "./sales-nav-steps.vue?vue&type=template&id=542afc30"
import script from "./sales-nav-steps.vue?vue&type=script&lang=js"
export * from "./sales-nav-steps.vue?vue&type=script&lang=js"

import "./sales-nav-steps.vue?vue&type=style&index=0&id=542afc30&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__